<template>
  <div class="table-responsive">
    <table class="table table-striped table-bordered">
      <thead class="table-dark">
      <tr>
        <th scope="col">{{ $t("judge.table.img") }}</th>
        <th scope="col">{{ $t("judge.table.name") }}</th>
        <th scope="col">{{ $t("judge.table.status") }}</th>
        <th v-if="isDisable" scope="col">{{ $t("judge.table.actions") }}</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="judge in judges" :key="judge.id" @click.prevent="$emit('viewJudge', judge.user.id)">
        <td><img :src="judge.user.img_path" alt="judge.name" class="judge-img" /></td>
        <td>
          <div class="name-cell">
            <span>
              {{ judge.user.name }} {{ judge.user.surname }}
              <i v-if="isLiveCompetition && isTechQualified(judge)" class="fa-solid fa-video tech-icon" aria-hidden="true"></i>
            </span>
            <span v-if="isLiveCompetition && isTechQualified(judge)" class="tech-status">
              {{ isTechActive(judge) ? 'Tecnico activo' : 'Tecnico disponible' }}
            </span>
          </div>
        </td>
        <td>
          <i class="fa-solid fa-check-circle" :class="{'approved': judge.status_id === 4, 'pending': judge.status_id !== 4}"></i>
          {{ judge.status.name }}
        </td>
        <td v-if="isDisable" class="action-buttons" @click.stop>
          <button class="action-btn delete"
                  @click="modalDelete(judge.id)"
                  v-if="judge.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at">
            <i class="fa-solid fa-xmark"></i>
          </button>
          <button class="action-btn confirm"
                  @click="modalConfirm(judge.id)"
                  v-if="judge.status_id === 2 && isOwnerAthlete(user, judge) && !competition.started_at">
            <i class="fa-solid fa-thumbs-up"></i>
          </button>

          <button class="action-btn reject"
                  @click="modalReject(judge.id)"
              v-if="judge.status_id !== 1 && (isOwnerAthlete(user, judge) || isOwnerOrganizer(user, competition)) && !competition.started_at">
            <i class="fa-solid fa-user-slash"></i>
          </button>

          <button class="action-btn mail"
                  v-if="judge.status_id === 1 && isOwnerOrganizer(user, competition) && !competition.started_at"
                  @click="modalSendEmail(judge.id)"
                  :title="$t('judge.send_mails_judges')">
            <i class="fa-solid fa-mail-bulk"></i>
          </button>

          <button class="action-btn approve"
                  @click="modalApprove(judge.id)"
                  v-if="judge.status_id === 3 && isOwnerOrganizer(user, competition) && !competition.started_at">
            <i class="fa-solid fa-check"></i>
          </button>
          <button
            v-if="canManageTechOperator && isTechQualified(judge) && isApproved(judge)"
            class="action-btn tech"
            @click.stop="toggleTechOperator(judge)"
            :title="isTechActive(judge) ? 'Desactivar tecnico' : 'Activar tecnico'"
            :disabled="isTechToggleDisabled(judge)"
          >
            <i :class="isTechActive(judge) ? 'fa-solid fa-toggle-on' : 'fa-solid fa-toggle-off'"></i>
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { isOwnerAthlete, isOwnerOrganizer, isSupervisor } from "@/helpers/roleUtils";
import {mapState} from "vuex";

export default {
  name: "JudgeTable",
  props: {
    judges: {
      type: Array,
      required: true,
      default: () => [],
    },
    competition: {
      type: Object,
      required: true,
    },
    activeTechOperatorId: {
      type: [Number, String],
      default: null,
    },
    
  },
  computed:{
    ...mapState('user', ['user']),
    isDisable(){
      return this.judges.some(judge => judge.status_id !== 5);
    },
    isLiveCompetition() {
      return Number(this.competition?.type_id) === 2;
    },
    canManageTechOperator() {
      return this.isLiveCompetition &&
        (this.isOwnerOrganizer(this.user, this.competition) || this.isSupervisor(this.user));
    },
  },
  methods: {
    isOwnerOrganizer,
    isOwnerAthlete,
    isSupervisor,
    modalDelete(id) {
      this.$emit('update-show-modal', 'deleteJudge',id,this.$t('judge.modal.delete_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalReject(id) {
      this.$emit('update-show-modal', 'rejectJudge',id,this.$t('judge.modal.decline_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalConfirm(id) {
      this.$emit('update-show-modal', 'confirmJudge',id,this.$t('judge.modal.confirm_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalApprove(id) {
      this.$emit('update-show-modal', 'approveJudge',id,this.$t('judge.modal.approve_confirmation')); // 🔥 Emití solo si el usuario confirma
    },
    modalSendEmail(id) {
      this.$emit('update-show-modal', 'sendEmailJudge', id, this.$t('judge.modal.send_invitation_confirmation'));
    },
    isTechQualified(judge) {
      const flag = judge?.tech_operator_qualified;
      return flag === true || flag === 'true' || Number(flag) === 1;
    },
    isTechActive(judge) {
      const flag = judge?.tech_operator_active;
      return flag === true || flag === 'true' || Number(flag) === 1;
    },
    isApproved(judge) {
      return Number(judge?.status_id) === 4;
    },
    isTechToggleDisabled(judge) {
      if (!this.isApproved(judge)) return true;
      if (!this.activeTechOperatorId) return false;
      return Number(this.activeTechOperatorId) !== Number(judge?.id) && !this.isTechActive(judge);
    },
    toggleTechOperator(judge) {
      if (!this.isTechQualified(judge) || !this.canManageTechOperator) return;
      this.$emit('toggle-tech-operator', {
        competitionUserId: judge?.id,
        active: !this.isTechActive(judge),
      });
    },
  }
};
</script>

<style scoped>
.table-responsive {
  width: 100%;
  overflow-x: auto;
}

.table td, .table th {
  white-space: nowrap;
  text-align: center;
  vertical-align: middle;
}

.judge-img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.name-cell {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.tech-icon {
  color: #1b5bbf;
  font-size: 0.9em;
}

.tech-status {
  font-size: 11px;
  color: #6c757d;
}
.close-button {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 1.5em;
  color: #c00;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  font-weight: bold;
  transition: color 0.2s ease;
}

.close-button:hover {
  color: #900;
}
.truncate-text {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.action-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 16px;
  padding: 6px;
  transition: opacity 0.2s ease;
}
.action-btn.delete { color: #dc3545; }
.action-btn.confirm { color: #28a745; }
.action-btn.reject { color: #dc3545; }
.action-btn.mail { color: #c08b2f; }
.action-btn.payment { color: #ffc107; }
.action-btn.approve { color: #007bff; }
.action-btn.tech { color: #1b5bbf; }
.action-btn.tech:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.action-btn.tech:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.action-btn:hover {
  opacity: 0.75;
}


@media (max-width: 768px) {
  .table-responsive {
    overflow-x: auto;
  }
  .action-buttons {
    flex-wrap: nowrap;
  }
  .btn-sm {
    padding: 3px 5px;
    font-size: 10px;
  }
}
</style>
